
import YotpoHtml from "@/components/Yotpo/YotpoHtml";
import { checkUserLogin } from "@/helpers/userHelpers";
import { generalConstants } from "@/utils/constants";
import { addProductToCart } from "@/helpers/cartHelpers";
import { isDonationProduct } from "@/helpers/pdpHelpers/priceHelpers";
import { addToCart, openMiniCart } from "@/redux/actions/addToCartAction";
import { getCookie } from "cookies-next";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GlobalLoader from "../common/GlobalLoader.js";

const Rewards = () => {
  const dispatch = useDispatch();

  /* Redux sates */
  let logUser = useSelector((state) => state.loginUser);
  let yotpo_details=logUser?.yotpoDetails;
  const [userLoggedIn,setUserLoggedinFlag]=useState(false);
  const [yotpo_present, setYotpoPresent] = useState(false);
  const [yotpo_hero_image, setYotpoHeroImage] = useState();
  const [yotpo_hero_image_mobile, setYotpoHeroImageMobile] = useState();
  const [yotpo_hero_image_default, setYotpoHeroImageDefault] = useState(generalConstants.yotpo_default_header_image);
  const [yotpo_hero_image_mobile_default, setYotpoHeroImageMobileDefault] = useState(generalConstants.yotpo_default_header_image_mobile);
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  useEffect(() => {
    if(yotpo_details) {
        setYotpoPresent(true);
        setYotpoHeroImage(yotpo_details.yotpo_hero_image)
        setYotpoHeroImageMobile(yotpo_details.yotpo_hero_image_mobile)
    }
  }, [yotpo_details]);

  const validateAccessToken = async (token) => {
    let user_data = await checkUserLogin(token);

    if (user_data && user_data.userLoggedIn) {
      setUserLoggedinFlag(true);
    }
  }

  useEffect(() => {
    if (getCookie("userdataToken")) {
      let cookie_data = JSON.parse(getCookie("userdataToken"));
      validateAccessToken(cookie_data.accessToken);
    }
  })
  const cause_list = useSelector((state) => state.general.cause_list);
  const cart_list = useSelector((state) => state.click.cart_list);

  /* States */
  const [cartList, setCartList] = useState(null)
  const [freeProductInCart, setFreeProductInCart] = useState(false);
  const [donationCollection, setDonationCollection] = useState();

  const donationAction = async (data) => { // Triggers when click on the Donate now button 

    /***********/
    // ***********
      /* Fix the issue with ® title */
    // ***********
    /***********/


    
    /* Get the variant ID and donation amount of the selected donation product */
    // let donationData;
    // donationCollection.every(item => {
    //   item = item.node;
    //   let variant = item.variants.nodes.find(variant => {
    //     let vid = variant.id.split('/');
    //     vid = vid[vid.length - 1];
    //     return vid === data.variantId
    //   })
    //   if (variant) {
    //     let currentCause = cause_list.find(item => {
    //       return item.name === variant.title
    //     })
    //     donationData = { amount: item.donation_amount.value, currentCause: currentCause.short_code }
    //     return false;
    //   }
    // })

    /* Donation product data for add to cart  */
    let request = {
      variantId: 'gid://shopify/ProductVariant/' + data.variantId,
      quantity: '1',
      lineItemCustomAttributes: [
        {
          key: '_swell_redemption_id',
          value: data.id.toString()
        },
        {
          key: '_swell_redemption_token',
          value: data.token
        },
        {
          key: '_swell_points_used',
          value: data.costInPoints.toString()
        }
        // {
        //   key: '_donation_amount',
        //   value: donationData.amount
        // },
        // {
        //   key: '_cause',
        //   value: donationData.currentCause
        // }
      ]
    }

    /* add to cart and after events */
    let response = await addProductToCart(request, {}, true);
    setFreeProductInCart(false);
    dispatch(addToCart(response));
    dispatch(openMiniCart(true));
    setTimeout(() => {
      dispatch(openMiniCart(false));
    }, 5000);
    if (response.id) {
      return true;
    }
    return false
  }
  const checkDonationProduct = () => {
    /* to check if the donation product is in the cart or not */
    if (!cartList || !cartList.lines) {
      return;
    }
    let isDonation = cartList.lines?.edges?.find(item => {
      let product = item?.node?.merchandise?.product;
      if (!product) {
        return false;
      }
      return isDonationProduct(product);
    })
    setFreeProductInCart(isDonation);
  }

  // const getDonationCollection = async () => {
  //   /* Get all donation products data  */
  //   const res = await client("collection-by-handle", { collection: 'donations' });
  //   res = await res.json();

  //   if (res && res.products && res.products.edges) {
  //     setDonationCollection(res.products.edges);
  //   }

  // }
  useEffect(() => {
    /* Yotpo function. Do not rename it */
    window.onProductRedemption = donationAction;
    setCartList(cart_list);
    checkDonationProduct();
  });
  // useEffect(() => {
  //   getDonationCollection();
  // }, []);
  let customer = logUser?.userData;
  let customerId;
  if (!getCookie("userdataToken")) {
    return (
      <>
        <YotpoHtml user_loggedIn={userLoggedIn} yotpo_hero_image={yotpo_hero_image_default} yotpo_hero_image_mobile={yotpo_hero_image_mobile_default} />
      </>
    )
  }
  if (!(customer && yotpo_hero_image)) {
    return (
      <div className="gif_loader">
        <GlobalLoader />
      </div>
    )
  }
  customerId = atob(customer.id).split('/');
  customerId = customerId[customerId.length - 1];
  if ((customer && yotpo_hero_image)) {
    return (
      <>
        <div id="swell-customer-identification" data-authenticated="true"
          data-email={customer.email}
          data-id={customerId}
          data-tags={JSON.stringify(customer.tags)}
          style={{ display: 'none' }}>
        </div>
        <div
          id="yotpo-loyalty-cart-data"
          data-cart-currency="USD"
          data-cart-id={cartList ? cartList.id : null}
          data-has-free-product={freeProductInCart ? true : false}>
        </div>
      <YotpoHtml user_loggedIn={userLoggedIn} yotpo_hero_image={yotpo_hero_image} yotpo_hero_image_mobile={yotpo_hero_image_mobile} />
      </>
    );
  }

};



export default Rewards;
